import EditImage from 'components/EditImage'

import './style.scss'

const EditWallpaper = ({ url, onSelect }) => {
  return (
    <EditImage
      id="wallpaper"
      url={url}
      alt="cover photo"
      className="EditWallpaper"
      onSelect={onSelect}
      defaultURL="/images/transparent-bg.png"
    />
  )
}

export default EditWallpaper
